import {existingUnits} from 'utilities/helper/existingUnitsOption';

export const qualifyInitialValues = (farm: IFarmAddInfo | undefined) => {
  return {
    existing: farm?.existing ? farm.existing : '',
    existing_unit: farm?.existing_unit
      ? farm.existing_unit
      : existingUnits[0].value?.toString(),
  };
};
